import React from 'react';
import propTypes from 'prop-types';

export const TourNameIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      fill={color}
      height={sizeInPixel}
      width={sizeInPixel}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 511.999 511.999"
      xmlSpace="preserve"
      className={variant}
    >
      <g>
        <g>
          <path d="M510.818,235.751L454.532,74.746c-2.961-8.47-10.953-14.142-19.925-14.142h-65.759    c-62.705-61.532-162.846-61.66-225.682,0H77.408c-8.972,0-16.965,5.672-19.925,14.142L1.197,235.751    c-4.794,13.715,5.408,28.073,19.925,28.073H45.48v212.661c0,11.657,9.45,21.107,21.107,21.107c16.762,0,361.959,0,378.841,0    c11.657,0,21.107-9.45,21.107-21.107V263.823c23.637,0,33.653,2.261,41.57-8.89C512.062,249.355,513.073,242.207,510.818,235.751z     M50.861,221.609L92.39,102.818h19.269c-19.859,38.098-20.608,77.553-8.433,118.791C59.148,221.609,70.315,221.609,50.861,221.609    z M87.694,455.378V263.823h31.02c25.649,61.764,65.602,134.331,99.699,191.554H87.694z M277.118,285.447    c0,11.657-9.45,21.107-21.107,21.107c-0.001,0-0.003,0-0.004,0s-0.003,0-0.004,0c-11.657,0-21.107-9.45-21.107-21.107v-85.456    c0-11.657,9.45-21.107,21.107-21.107c0.001,0,0.003,0,0.004,0s0.003,0,0.004,0c11.657,0,21.107,9.45,21.107,21.107V285.447z     M277.118,138.405c0,11.657-9.45,21.107-21.107,21.107c-0.001,0-0.003,0-0.004,0s-0.003,0-0.004,0    c-11.657,0-21.107-9.45-21.107-21.107v-20.404c0-11.657,9.45-21.107,21.107-21.107c0.001,0,0.003,0,0.004,0s0.003,0,0.004,0    c11.657,0,21.107,9.45,21.107,21.107V138.405z M424.321,455.378H293.603c34.095-57.22,74.049-129.795,99.697-191.554h31.021    V455.378z M408.789,221.609c12.173-41.238,11.426-80.693-8.433-118.791h19.269l41.529,118.791    C441.699,221.609,452.867,221.609,408.789,221.609z" />
        </g>
      </g>
    </svg>
  );
};
TourNameIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
TourNameIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
